import classNames from 'classnames';
import React from 'react';
import { useTheme } from '@components/theme';
import styles from './CTA.module.scss';
import Stars from './assets/yellow-stars.svg';

interface IDiscoverBestSellersProps {
  className?: string;
  size: string;

}

const DiscoverBestSellers = ({ className }: IDiscoverBestSellersProps) => {
  const theme = useTheme();

  return (
    <div className={
      classNames(
        styles.CTACard,
        className
      )
    }
    >
      <div className={styles.Contents}>
        <a href={'/shop'}>
          <Stars />
          <div className={classNames(theme.styles.Title2, styles.PrimaryText)}>
            Discover Bestsellers
          </div>
          <div className={styles.SecondaryText}>Shop Now</div>
        </a>
        <div className={ styles.Overlay } />
      </div>
    </div>
  );
};

export default DiscoverBestSellers;
